import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_json_editor_vue = _resolveComponent("json-editor-vue")!

  return (_ctx.snapshot && _ctx.snapshot.content)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", null, "Snapshot " + _toDisplayString(_ctx.$route.params.id), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.snapshot.content.description), 1),
        _createVNode(_component_json_editor_vue, _mergeProps({
          modelValue: _ctx.snapshot.content,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.snapshot.content) = $event))
        }, { flattenColumns: true }), null, 16, ["modelValue"]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeSnapshot(_ctx.snapshot)))
        }, "Delete"),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update(_ctx.snapshot)))
        }, "Save")
      ]))
    : _createCommentVNode("", true)
}